// extracted by mini-css-extract-plugin
export default {"container":"ResponsiveTable_container__9Gfhj","table":"ResponsiveTable_table__RBeQU"};